'use strict';
import template from './mx-push-notifications-panel.component.html';

export class PushNotificationsPanelController {
	static $inject = [
		'mx.sb.PushNotifications.NotificationsService',
		'mx.internationalization',
		'$scope',
		'mx.SolutionBuilderAgent.WidgetManager',
		'mx.shell.RoutingService',
		'mx.shell.SidePanelService',
	];

	constructor(pushNotificationsService, i18n, $scope, widgetManager, routingService, sidePanelService) {
		Object.assign(this, { pushNotificationsService, i18n, $scope, widgetManager, routingService, sidePanelService });

		this.actions = this.initActions();
		this.browsersHelpInfo = this.getBrowsersHelpInfo();
	}

	$onInit() {
		this._unsubscribe = this.pushNotificationsService.addNotificationsUpdatedHandler((notifications) => this._onNotificationsUpdated(notifications));
		this._onNotificationsUpdated(this.pushNotificationsService.notifications);
	}

	$onDestroy() {
		this._unsubscribe();
	}

	initActions() {
		const vm = this;
		return [
			{
				name: 'delete_all',
				title: this.i18n.get('shell.common.delete_all'),
				icon: 'delete',
				enabled: true,
				controller: function () {
					vm.pushNotificationsService.removeAllNotifications();
				},
			},
		];
	}

	getBrowsersHelpInfo() {
		const agent = window.navigator.userAgent;
		const notSupportedI18n = `<i>${this.i18n.get('solutionBuilderAgent.push-notifications.browserIsNotSupported')}</i>`;
		const browsers = [
			{
				name: 'Chrome',
				isCurrent: agent.indexOf('Chrome') > -1 && agent.indexOf('Edg/') === -1,
				link: 'https://support.google.com/chrome/answer/3220216',
			},
			{
				name: 'Firefox',
				isCurrent: agent.indexOf('Firefox') > -1,
				link: 'https://support.mozilla.org/en-US/kb/push-notifications-firefox',
			},
			{
				name: 'Edge',
				isCurrent: agent.indexOf('Edg/') > -1,
				link: 'https://answers.microsoft.com/en-us/edge/forum/edge_issue-edge_win10/turn-on-off-microsoft-edge-pop-up-notifications/1e804ae0-788d-46b0-a414-739231e8eaa3',
			},
			{
				name: 'Internet Explorer',
				isCurrent: agent.indexOf('MSIE ') > -1 || !!agent.match(/Trident.*rv:11\./),
				link: '',
			},
			{
				name: 'Safari',
				isCurrent: agent.indexOf('Safari') > -1 && agent.indexOf('Chrome') === -1,
				link: '',
			},
		];
		const currentBrowser = browsers.find((b) => b.isCurrent);

		let resHtml = '<ul>';
		if (currentBrowser) {
			resHtml += `<li>
					<b>
						${currentBrowser.name}
						<i>(${this.i18n.get('solutionBuilderAgent.push-notifications.currentBrowser')})</i> :
						${currentBrowser.link ? `<br /><a href="${currentBrowser.link}" target="_blank">${currentBrowser.link}</a>` : notSupportedI18n}
					</b>
				</li>`;
		}
		browsers.forEach((b) => {
			if (b !== currentBrowser) {
				resHtml += `<li>
					${b.name}:
					${b.link ? `<br /><a href="${b.link}" target="_blank">${b.link}</a>` : notSupportedI18n}
				</li>`;
			}
		});
		resHtml += '</ul>';

		return resHtml;
	}

	async activate() {
		await this.pushNotificationsService.activate();
		this.$scope.$evalAsync();
	}

	_onNotificationsUpdated(notifications) {
		if (this.pushNotificationsService.unreadNotifications > 0) {
			this.pushNotificationsService.setNotificationsRead();
		}
		this.viewData = this._prepareViewData(notifications);
		this.groups = this._groupNotificationsByTime(notifications);
		this.$scope.$evalAsync();
	}

	_groupNotificationsByTime(notifications) {
		const groups = [];
		const groupsObj = {};

		notifications.forEach((notification) => {
			const timeAgo = Date.now() - notification.received < 3000000 ? this.i18n.get('components.common.recently') : this.i18n.formatDate(notification.received, 'timeAgo');

			if (groupsObj[timeAgo]) {
				groupsObj[timeAgo].notifications.push(notification);
			} else {
				const newGroup = {
					title: timeAgo,
					notifications: [notification],
				};
				groupsObj[timeAgo] = newGroup;
				groups.push(newGroup);
			}
		});

		return groups;
	}

	_prepareViewData(notifications) {
		return notifications.reduce((viewData, notification) => {
			viewData[notification.id] = {
				date: this.i18n.formatDate(notification.received, 'MMM D, YYYY LT'),
			};

			if (notification.url) {
				viewData[notification.id].onClick = () => this.routingService.goToUrl(notification.url, true);
			} else if (notification.objectId && notification.entityType) {
				viewData[notification.id].onClick = async () => {
					let view;
					try {
						view = await this.widgetManager.getPreviewView({
							_id: notification.objectId,
							_type: notification.entityType,
						});
					} catch (e) {
						mx.noLogCatchMessage(e);
					}
					if (view) {
						this.sidePanelService.addView(view);
					} else {
						this.routingService.goToUrl(`/object-details/${notification.entityType}/${notification.objectId}/`, true);
					}
				};
			}

			return viewData;
		}, {});
	}
}

export default {
	template: template,
	controllerAs: 'vm',
	controller: PushNotificationsPanelController,
};
